import { identify } from '@mc/track-event'
import { trackEmailCapture, EmailCaptureParams } from '../api/segment'

export const useTrackEmailCaptured =
  () =>
  async (payload: {
    event: string
    properties?: Record<
      string,
      string | number | boolean | object | null | undefined
    >
    integrations?: Record<string, boolean>
  }) => {
    // Identify user for FE event tracking if cookies are enabled
    identify(null, {
      email: payload.properties?.email,
      integrations: { Iterable: true },
    })

    const emailCaptureParams: EmailCaptureParams = {
      email: payload.properties?.email as string,
      event_name: payload.event,
      page_source: payload.properties?.page_source as string,
      campaign: payload.properties?.campaign as string,
      location: payload.properties?.location as string,
      content_type: payload.properties?.contentType as string,
      slug: payload.properties?.slug as string,
      category: payload.properties?.category as string,
    }

    // Track (and identify) on BE since cookies might be disabled
    await trackEmailCapture(emailCaptureParams)
  }
